<template>
<div class="page page_hezuo" >
    <!-- style="height: 100vh; margin-bottom:2.59rem;overflow: auto;" -->
    <van-cell-group class="add_back" style="height: 80vh; ;overflow: auto;">
        <van-cell class="add_cell_2" >
            <van-field
                v-model="info.content"
                rows="3"
                autosize
                label=""
                type="textarea"
                placeholder="请说出这些照片的故事"
            />
        </van-cell>
        <div class="uploadTu">
            <!-- <div class="title">上传图片</div> -->
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in info.album" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
        <van-cell class="add_cell" title="时间" :value="info.time" @click="selectDate" is-link/>
        <van-cell class="add_cell" title="分类" :value="info.cate" @click="selectCate" is-link/>
        <!-- <van-cell class="add_cell" >
            <van-field v-model="name" label="标签" placeholder="为故事分类" input-align="right"/>
        </van-cell> -->
    </van-cell-group>
    <div class="big_btn bottom" style="background-color: #000;" @click="addNewPhoto">{{id?'修改':'发布'}}</div>
    <van-popup v-model="showDate" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="选择时间" :min-date="minDate" :max-date="maxDate" @confirm="confirmTime" @cancel="showDate=false" />
    </van-popup>
    <van-popup v-model="showCate" position="bottom">
        <van-picker show-toolbar :columns="cateList" value-key="title" @confirm="confirmCate" @cancel="showCate = false"  />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            id: this.$route.query.id,
            info: {
                time: '',
                album: [],
                cate: '',
                cate_id: ''
            },
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(),
            currentDate: new Date(),
            cateList: [],
            timepicker: false, // 时间插件pop层
            loading: false,
            refreshing: false,
            showDate: false,
            showCate: false,
            isLoading: false
        };
    },
    created: function () {
        var that = this
        this.info.time = this.formatDate(new Date()) 
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '图集管理',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                
                responseCallback(data)
            })
        } else {
            that.token = this.$store.getters.token
            console.log('this.id222:',this.id)
            that.getData()
            // 获取列表
        }
    },
    mounted: function () {
    },
    methods: {
        getData() {
            this.getCate()
            var that = this
            if (!this.id || this.id == undefined || this.id == '') {
                return
            }
            var params = {
                token: this.token,
                thumb_id: this.id,
            }
			this.$api.tradesman.thumbDetail(params).then(res=>{
				if(res.code == 200){
                    that.info = res.result
                    that.currentDate = new Date(this.info.time)
				} 
			})
        },
        getCate() {
            var that = this
            var params = {
                token: this.token,
            }
			this.$api.tradesman.thumbCate(params).then(res=>{
				if(res.code == 200){
                    that.cateList = res.result
                    // if (that.cateList && that.cateList.length > 0) {
                    //     if (that.id == null || that.id == undefined || that.id == '') {
                    //         var cate = that.cateList[0]
                    //         that.info.cate = cate.title
                    //         that.info.cate_id = cate.id
                    //     }
                    // }
				} 
			})
        },
        selectDate() {
            this.showDate = true
        },
        selectCate() {
            this.showCate = true
        },
        confirmCate(val){
			this.info.cate = val.title
			this.info.cate_id = val.id
            this.showCate = false
		},
        // 删除图片
        imgDel(index) {
            this.info.album.splice(index, 1);
        },
        addNewPhoto() {
            var that = this
            if (this.info.album.length <= 0) {
                Toast('请上传图片')
                return
            }
            if (this.info.time == null || this.info.time == undefined || this.info.time == '') {
                Toast('请选择时间')
                return
            }
            if (that.isLoading) {
                return
            }
            that.isLoading = true
            var params = {
                title: '',
                token: this.token,
                cate_id: that.info.cate_id,
                album: that.info.album.join(','),
                time: this.info.time,
                content: this.info.content,
                tag: ''
            }
            if (this.id && this.id != undefined && this.id != '') {
                this.$api.tradesman.thumbEdit(params).then(res=>{
                    if(res.code == 200){
                        Toast(res.message)
                        setTimeout(() => {
                            console.log('back')
                            that.isLoading = false
                            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                var params = {}
                                this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                                })
                            } else {
                                that.$router.back()
                            }
                        }, 2000);
                    } else {
                        Toast(res.message)
                        that.isLoading = false
                    }
                    
                })
            } else {
                this.$api.tradesman.thumbAdd(params).then(res=>{
                    if(res.code == 200){
                        Toast(res.message)
                        setTimeout(() => {
                            console.log('back')
                            that.isLoading = false
                            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                var params = {}
                                this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                                })
                            } else {
                                that.$router.back()
                            }
                        }, 2000);
                    } else {
                        Toast(res.message)
                        that.isLoading = false
                    }
                    
                })
            }
            
        },
        confirmTime(value) {
            console.log('confirmTime', value)
            this.info.time = this.formatDate(value)
            this.showDate = false
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
			var day = date.getDate().toString();
            if (month.length == 1) {
                month = '0' + month;
            }
            if (day.length == 1) {
                day = '0' + day;
			}
            return `${year}-${month}-${day}`;
        },
        // 上传图片
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.info.album.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.info.album.push(res.result.url);
                    }
                });
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
